module.exports = __webpack_public_path__ + "img/banner_ar.2f6b3ed7.jpg";